/**
 * 监听el-select组件远程搜索时触碰底部
 * @param {Function} callback 回调函数
 * @example
 * <el-select v-select-load-more="callback"></el-select>
 */

export default {
  updated(el, binding) {
    const SELECTDOWN_DOM = el.querySelector('.el-scrollbar .el-select-dropdown__wrap');
    SELECTDOWN_DOM.addEventListener('scroll', function () {
      const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight;
      if (CONDITION) {
        binding.value();
      }
    });
  }
};
